import React from 'react'
import { withRouter, Link } from 'react-router-dom';
import { withFirebase } from '../firebase';
import appLogo from '../../images/logo.png'
import '../styles/login.css';
import Loader from 'react-loader-spinner';
import ModalInfo from '../useful/ModalInfo';

const INITIAL_STATE = {
    loading: false,
    email: '',
    password: '',
    modal: {
        show: false,
        title: '',
        message: ''
    }
};

// Modal.setAppElement('#root');
class Login extends React.Component {

    constructor(props) {
        super(props);
        this.state = { ...INITIAL_STATE };
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleSignIn = (e) => {
        e.preventDefault();

        const { email, password } = this.state;
        const isInvalid = password === '' || email === '';

        if (!isInvalid) {
            this.setState({ loading: true });

            this.props.firebase
                .doSignInWithEmailAndPassword(email, password)
                .then(() => {
                    this.props.history.push("/");
                    this.setState({ ...INITIAL_STATE });
                })
                .catch(error => {
                    this.setState({ loading: false });
                    this.showErrorModal("Los datos introducidos son incorrectos");
                    console.log("Error: ", error);
                });
        } else {
            this.showErrorModal("Los datos introducidos son incorrectos");
        }
    }

    showErrorModal = (message) => {
        this.setState({
            modal: {
                show: true,
                title: 'Error',
                message: message
            }
        });
    }

    closeErrorModal = () => {
        this.setState({
            modal: {
                show: false,
                title: '',
                message: ''
            }
        });
    }

    render() {
        const { loading, email, password, modal } = this.state;
        const isInvalid = password === '' || email === '';

        return (
            <div className="mt-4 row justify-content-center align-items-center" >

                <form className="form-signin text-center" onSubmit={this.handleSignIn}>
                    <img className="mb-4" src={appLogo} alt="" height="72" />
                    <h4 className=" mb-3 font-weight-normal">Iniciar Sesión</h4>


                    <div className="form-group text-left">
                        <label className="small text-secondary mb-0 ml-1" htmlFor="email">Correo electrónico:</label>
                        <input onChange={this.handleChange} className="form-control" type="text" id="email" name="email" placeholder="example@mail.com" required="" />
                    </div>

                    <div className="form-group text-left">
                        <label className="small text-secondary mb-0 ml-1" htmlFor="password">Contraseña:</label>
                        <input onChange={this.handleChange} className="form-control" type="password" id="password" name="password" placeholder="......" required="" />
                    </div>

                    {/* <input onChange={this.handleChange} name="email" type="email" className="form-control" placeholder="Email" required="" /> */}

                    {/* <input onChange={this.handleChange} name="password" type="password" className="form-control mt-3" placeholder="Contraseña" required="" /> */}

                    {(!loading) ?
                        <>
                            <button disabled={isInvalid} className="mt-3 btn btn-lg btn-app btn-block" type="submit">Acceder</button>
                            <br />
                            <Link to="/password_reset">
                                Olvidé mi contraseña!!
                            </Link>
                        </>
                        :
                        <div className="nav justify-content-center row">
                            <Loader className="mt-4"
                                type="ThreeDots"
                                color="#263238"
                                height={60}
                                width={60}
                                timeout={0} />
                        </div>
                    }

                    <p className="mt-5 mb-3 text-muted">©fairplay-2020</p>
                </form>

                <ModalInfo
                    data={modal}
                    onClose={this.closeErrorModal}
                />

            </div>
        );
    }
}


export default withRouter(withFirebase(Login));